import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'
import { parseWorkflowDetailTab } from '@/pages/workflow-detail/workflow-detail-tabs'

export const Route = createFileRoute('/_protected/workflows/$agentId')({
  component: lazyRouteComponent(() => import('@/pages/workflow-detail/page'), 'WorkflowDetailPage'),
  validateSearch: (search: Record<string, unknown>) => ({
    tab: parseWorkflowDetailTab(search.tab),
  }),
})
